import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------
const role = localStorage.getItem("role");

export default function GamePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/admin/games`)
      .then(function (response) {
        setRows(response.data.games);
      })
      .catch(function (error) {
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("role");
        window.location.href = "/";
      });
  }, []);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const deleteGameHandler = () => {
    setLoading(true);
    setOpen(false);
    setOpenConfirm(false);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/admin/game/${openId}/delete`)
      .then(function (response) {
        window.location.reload(false);
      });
  };

  return (
    <>
      <Helmet>
        <title> Bingo Games </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Bingo Games
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() =>
              process.env.REACT_APP_LEAGUE_NAME === "golf"
                ? navigate("/dashboard/new-custom-game")
                : navigate("/dashboard/new-game")
            }
          >
            New Bingo Game
          </Button>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Questions</TableCell>
                      <TableCell align="center">Status</TableCell>
                      <TableCell align="center">Tenant</TableCell>
                      <TableCell align="center">Start UTC</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.questionsCount}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.status}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.tenant}
                        </TableCell>
                        <TableCell align="right">{row.kickoff}</TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.gameId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() =>
            navigate(`/dashboard/game/questions?game_id=${openId}`)
          }
        >
          <Iconify icon={"eva:list-outline"} sx={{ mr: 2 }} />
          Questions
        </MenuItem>

        <MenuItem
          onClick={() => navigate(`/dashboard/game/users?game_id=${openId}`)}
        >
          <Iconify icon={"eva:keypad-outline"} sx={{ mr: 2 }} />
          Cards
        </MenuItem>

        <MenuItem
          onClick={() => navigate(`/dashboard/game/results?game_id=${openId}`)}
        >
          <Iconify icon={"eva:award-outline"} sx={{ mr: 2 }} />
          Results
        </MenuItem>
        {process.env.REACT_APP_NAME !== "olybet" ? (
          <MenuItem
            onClick={() => navigate(`/dashboard/game/codes?game_id=${openId}`)}
          >
            <Iconify icon={"eva:paper-plane-outline"} sx={{ mr: 2 }} />
            Codes
          </MenuItem>
        ) : null}

        {role !== "VIEWER" && (
          <>
            <MenuItem
              onClick={() => navigate(`/dashboard/game/edit?game_id=${openId}`)}
            >
              <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
              Edit
            </MenuItem>
            <MenuItem
              sx={{ color: "error.main" }}
              onClick={() => setOpenConfirm(true)}
            >
              <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
              Delete
            </MenuItem>
          </>
        )}
      </Popover>
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete Game?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            All questions and cards would be deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button onClick={() => deleteGameHandler(true)} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
